import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Renderer2,
  AfterViewInit,
} from "@angular/core";

import { ROUTES as ROUTES_ADMIN } from "./admin/sidebar-routes.config";
import { ROUTES as ROUTES_DEVELOPER } from "./developer/sidebar-routes.config";
import { ROUTES as ROUTES_NETWORK } from "./network/sidebar-routes.config";
import { ROUTES as ROUTES_MOCKUPS } from "./mockups/sidebar-routes.config";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { customAnimations } from "../animations/custom-animations";
import { ConfigService } from "../services/config.service";
import { SecurityService } from "../services/security.service";
import { Subscription } from "rxjs";
import { Roles } from "../models/roles.model";
import { RouteInfo } from "./sidebar.metadata";
import { ConfigurationService } from "../services/configuration.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
  animations: customAnimations,
})
export class SidebarComponent implements OnInit, AfterViewInit {
  @ViewChild("toggleIcon") toggleIcon: ElementRef;
  public menuItems: RouteInfo[];
  depth: number;
  activeTitle: string;
  activeTitles: string[] = [];
  expanded: boolean;
  nav_collapsed_open = false;
  logoUrl = "";
  identityUrl = "";
  spWebUrl = "";
  returnUrl = document.baseURI;
  public config: any = {};
  private authSubscription: Subscription;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private configService: ConfigService,
    private securityService: SecurityService,
    private configurationService: ConfigurationService
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
      this.expanded = true;
    }
  }

  ngOnInit() {
    this.config = this.configService.templateConf;
    this.identityUrl = this.configurationService.serverSettings.identityUrl;
    this.spWebUrl = this.configurationService.serverSettings.spWebUrl;
    this.setMenuItems();
    this.authSubscription = this.securityService.authenticationChallenge$.subscribe(
      (res) => this.setMenuItems()
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.config.layout.sidebar.collapsed != undefined) {
        if (this.config.layout.sidebar.collapsed === true) {
          this.expanded = false;
          this.renderer.addClass(
            this.toggleIcon.nativeElement,
            "ft-chevrons-left"
          );
          this.renderer.removeClass(
            this.toggleIcon.nativeElement,
            "ft-chevrons-right"
          );
          this.nav_collapsed_open = true;
        } else if (this.config.layout.sidebar.collapsed === false) {
          this.expanded = true;
          this.renderer.removeClass(
            this.toggleIcon.nativeElement,
            "ft-chevrons-left"
          );
          this.renderer.addClass(
            this.toggleIcon.nativeElement,
            "ft-chevrons-right"
          );
          this.nav_collapsed_open = false;
        }
      }
    }, 0);
  }

  toggleSlideInOut(menuItem) {
    this.activeTitles = [];
    this.activeTitles.push(menuItem.title);
    this.expanded = !this.expanded;
  }

  handleToggle(titles) {
    this.activeTitles = titles;
  }

  // NGX Wizard - skip url change
  ngxWizardFunction(path: string) {
    if (path.indexOf("forms/ngx") !== -1) {
      this.router.navigate(["forms/ngx/wizard"], { skipLocationChange: false });
    }
  }

  private setMenuItems() {
    this.menuItems = ROUTES_MOCKUPS;
    const user = this.securityService.UserData;
    if (user && user.role === Roles.Administrator) {
      this.menuItems = this.menuItems.concat(ROUTES_ADMIN);
    } else if (user && user.role === Roles.Developer) {
      this.menuItems = this.menuItems.concat(ROUTES_DEVELOPER);
    } else if (user && user.role === Roles.Network) {
      this.menuItems = this.menuItems.concat(ROUTES_NETWORK);
    }

    const itemsTempalte = JSON.stringify(this.menuItems)
      .replace(/{{spWebUrl}}/g, this.spWebUrl)
      .replace(/{{identityUrl}}/g, this.identityUrl)
      .replace(/{{returnUrl}}/g, this.returnUrl);

    this.menuItems = JSON.parse(itemsTempalte);
  }
}
